module.exports = __webpack_public_path__ + "static/media/LogoSmartPlan.999cf688.svg";